<template>
  <div class="page page-with-bg">
    <div class="page-form-wrap">
      <div class="page-form-header">
        <h1>Client Resources</h1>
      </div>
      <div class="description d-flex">
        <div>
          <h4 class="mb-4">Links to Support Materials:</h4>
          <a href="https://precisionhealthreports.com/s/Rationale-for-the-use-of-GlycA-to-Quantify-Systemic-Inflammation-Final-20210705.pdf" target="_blank">
            Clinical rationale for using GlycA instead of hsCRP
          </a> <br />
          <a href="https://precisionhealthreports.com/s/Optimizing-Identification-of-Diabetic-Risk-and-Response-to-Therapy-Final-20210705.pdf" target="_blank">
            Clinical rationale for using LP-IR to predict diabetes
          </a> <br />
          <a href="https://precisionhealthreports.com/s/Insulin-Resistance-and-Metabolic-Syndrome-Severity-Score-Final-20210705.pdf" target="_blank">
            Metabolic Syndrome Severity Score
          </a> <br />
          <a href="https://precisionhealthreports.com/noninvasive-imaging" target="_blank">
            Non-invasive Imaging Guide
          </a> <br />
          <div class="card-wrap">
            <b-card class="card-clickable resource-card png-icon py-3" @click="viewUploadModal">
              <svg-icon class="card-icon cloud-upload" name="cloud-upload"></svg-icon>
              <div class="card-title">Upload Lab Results for Client-drawn labs</div>
            </b-card>
          </div>
          <div class="card-wrap">
            <b-card class="card-clickable resource-card png-icon py-4" @click="viewVideoContent">
              <img class="video-content" src="../../../../Files/educational-video.png"/>
              <div class="card-title">Video Content</div>
            </b-card>
          </div>
        </div>
      </div>
    </div>
    <upload-lab-results-modal ref="uploadLabResultsModal"></upload-lab-results-modal>
  </div>
</template>

<script>
  import uploadLabResultsModal from './upload-lab-results-modal';

  export default {
    components: {
      'upload-lab-results-modal': uploadLabResultsModal,
    },

    data() {
      return {};
    },

    methods: {
      viewVideoContent() {
        this.$router.push("/information/video-content");
      },
      viewUploadModal() {
        this.$refs.uploadLabResultsModal.show();
      }
    }
  };
</script>

<style scoped lang="scss">
  @import '@/styles/_mixins';

  .page {
    @include retina('/png/keyboard.png');
  }
</style>